import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTachometerAlt, FaGlobe, FaCheckCircle, FaMicrophone, FaLightbulb } from 'react-icons/fa';

function CampaignSidebar({ onTabClick }) {
  const location = useLocation();

  const [aiServicesOpen] = useState(true);
  const [campaignsOpen] = useState(true);

  const handleTabClick = (path) => {
    if (onTabClick) {
      onTabClick(path);
    }
  };

  return (
    <div className="sidebar-container">
      <ul className="sidebar-tabs">
        <li className="sidebar-main">
          <div className="sidebar-parent">AI Services</div>
          <ul className={`ai-services-subclass ${aiServicesOpen ? 'open' : ''}`}>
            <li className={location.pathname === "/" ? "active" : ""}>
              <Link className="sidebar-link" to="/" onClick={() => handleTabClick("/")}>
                <FaTachometerAlt /> Dashboard
              </Link>
            </li>
            <li className={location.pathname === "/translation" ? "active" : ""}>
              <Link className="sidebar-link" to="/translation" onClick={() => handleTabClick("/translation")}>
                <FaGlobe /> Translation
              </Link>
            </li>
            <li className={location.pathname === "/copy-checker" ? "active" : ""}>
              <Link className="sidebar-link" to="/copy-checker" onClick={() => handleTabClick("/copy-checker")}>
                <FaCheckCircle /> Copy Checker
              </Link>
            </li>
            <li className={location.pathname === "/transcription" ? "active" : ""}>
              <Link className="sidebar-link" to="/transcription" onClick={() => handleTabClick("/transcription")}>
                <FaMicrophone /> Transcription
              </Link>
            </li>
          </ul>
        </li>

        <li className="sidebar-main">
          <div className="sidebar-parent">Campaigns</div>
          <ul className={`campaigns-subclass ${campaignsOpen ? 'open' : ''}`}>
            <li className={location.pathname === "/campaigns" ? "active" : ""}>
              <Link className="sidebar-link" to="/campaigns" onClick={() => handleTabClick("/campaigns")}>
                <FaTachometerAlt /> Dashboard
              </Link>
            </li>
            <li className={location.pathname === "/campaigns/insights" ? "active" : ""}>
              <Link className="sidebar-link" to="/campaigns/insights" onClick={() => handleTabClick("/campaigns/insights")}>
                <FaLightbulb /> Insights
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default CampaignSidebar;
